import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { authorizationApi } from "../../api/authorization";
import { apiRequestBase, unwrapResponse } from "../../api/client";
import { env } from "../../config/env";

async function fetchAndStoreBusinessDetails() {
  const data = await apiRequestBase<unknown>(
    env.sharedConfigBaseUrl,
    "/CompanySetting/Details",
  );
  localStorage.setItem("businessDetails", JSON.stringify(data));
}

async function fetchAndStoreBusinessProfile(email: string) {
  const response = await authorizationApi.getBusinessProfilesByEmail(email);
  const data = unwrapResponse<any[]>(response);
  if (!Array.isArray(data) || data.length === 0) return;

  const item = data[0];
  const profile = {
    id: String(
      item?.businessProfile?.id ??
        item?.businessProfileId ??
        item?.businessProfileID ??
        item?.BusinessProfileId ??
        item?.id ??
        "",
    ),
    name:
      item?.businessProfile?.name ??
      item?.businessName ??
      item?.name ??
      item?.Name ??
      "Business",
    plan:
      item?.subscriptionPlan?.name ??
      item?.packageName ??
      item?.planName ??
      item?.PlanName,
    status: item?.subscriptionStatus ?? item?.status ?? item?.Status,
    email: item?.userMail ?? item?.email ?? item?.Email,
    raw: item,
  };

  localStorage.setItem("biznifyBusinessProfile", JSON.stringify(profile));
  localStorage.setItem("clientBusinessProfile", JSON.stringify(item));
  if (profile.id) {
    localStorage.setItem("profileId", profile.id);
  }
  const rawUserId = item?.userId ?? item?.UserId;
  if (rawUserId != null) {
    localStorage.setItem("userId", String(rawUserId));
  }
}

export default function AuthCallback() {
  const { completeSignIn } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    const hasAuthParams =
      window.location.search.includes("code=") ||
      window.location.search.includes("error=") ||
      window.location.hash.includes("id_token=") ||
      window.location.hash.includes("access_token=");

    if (!hasAuthParams) {
      navigate("/pos-checkin", { replace: true });
      return () => {
        mounted = false;
      };
    }

    completeSignIn()
      .then(async (user) => {
        const returnUrl = (user?.state as string) || "/pos-checkin";
        const email =
          (user.profile as any)?.email ||
          (user.profile as any)?.Email ||
          (user.profile as any)?.upn ||
          "";
        if (email) {
          try {
            await fetchAndStoreBusinessProfile(email);
          } catch {
            // Non-fatal: profile fetch failed, checkin page will still load
          }
        }
        try {
          await fetchAndStoreBusinessDetails();
        } catch {
          // Non-fatal: business details fetch failed
        }
        if (mounted) navigate(returnUrl, { replace: true });
      })
      .catch((err: Error) => {
        if (!mounted) return;
        const msg = err.message ?? "";
        if (
          msg.toLowerCase().includes("no matching state") ||
          msg.toLowerCase().includes("invalid_grant")
        ) {
          navigate("/account/login", { replace: true });
        } else {
          setError(msg || "Login failed.");
        }
      });

    return () => {
      mounted = false;
    };
  }, [completeSignIn, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white rounded-lg shadow-md p-6 text-center">
        <h1 className="text-lg font-semibold text-gray-900 mb-2">
          Completing sign-in...
        </h1>
        <p className="text-sm text-gray-600">
          Please wait while we finish authentication.
        </p>
        {error && <p className="mt-3 text-sm text-red-600">Error: {error}</p>}
      </div>
    </div>
  );
}
